function Gridbutton({ topImage, itemName, isCollected, onTopClick, onBottomClick }) {
  const handleBottomClick = () => {
    if (onBottomClick) {
      onBottomClick();
    }
  };

  return (
    <div className="gridbutton">
      <div 
        className="gridbutton-top tooltip-container" 
        onClick={onTopClick}
      >
        {topImage && <img src={topImage} alt={itemName} className="gridbutton-img" />}
        <span className="tooltip">{itemName}</span>
      </div>
      <div 
        className={`gridbutton-bottom ${isCollected ? 'active' : ''}`}
        onClick={handleBottomClick}
      >
        
        
      </div>
    </div>
  );
}

export default Gridbutton;